import React from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { COUNT_DATA } from 'pages/Dashboard/components/constant';
import TransportationCount from './components/TransportationCount';
import VendorsCount from './components/VendorsCount';
import OrdersCount from './components/OrdersCount';
import NewListingCount from './components/NewListingCount';
import ActiveBidsCount from './components/ActiveBidsCount';

const CountCard = (props) => {
  const {
    activeTab,
    setActiveTab,
    selectedOption = 'day',
    permissions,
  } = props;
  return (
    <>
      {COUNT_DATA.map((item) => {
        return (
          <NavItem key={item.id}>
            <NavLink
              className={`border-0 m-0 ${
                activeTab === item.id ? 'active' : ''
              }`}
              onClick={() => setActiveTab(item.id)}
            >
              {item.title === 'Active Listing' && (
                <NewListingCount
                  item={item}
                  selectedOption={selectedOption}
                  canView={permissions?.listing}
                />
              )}
              {item.title === 'Active Bids' && (
                <ActiveBidsCount
                  item={item}
                  selectedOption={selectedOption}
                  canView={permissions?.bids}
                />
              )}
              {item.title === 'Vendors' && (
                <VendorsCount
                  item={item}
                  selectedOption={selectedOption}
                  canView={permissions?.vendors}
                />
              )}
              {item.title === 'Orders' && (
                <OrdersCount
                  item={item}
                  selectedOption={selectedOption}
                  canView={permissions?.orders}
                />
              )}
              {/* {item.title === 'Invoices' && (
                <TransportationCount
                  item={item}
                  selectedOption={selectedOption}
                />
              )} */}
            </NavLink>
          </NavItem>
        );
      })}
    </>
  );
};

export default CountCard;
